/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { 
  getInventoryHealth, 
  getRiskItems, 
  getInventorySuggestions 
} from "../api";
import InventoryDashboard from "../components/InventoryDashboard";
import IntegrationTab from "../components/IntegrationTab";

export default function Inventory() {
  const [health, setHealth] = useState(null);
  const [riskItems, setRiskItems] = useState([]);
  const [suggestions, setSuggestions] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    const fetchInventoryData = async () => {
      try {
        const healthRes = await getInventoryHealth();
        setHealth(healthRes);
        const riskRes = await getRiskItems();
        setRiskItems(riskRes.items || []);
        const suggestionsRes = await getInventorySuggestions();
        setSuggestions(suggestionsRes);
      } catch (err) {
        console.error("Failed to fetch inventory data:", err);
      }
    };
    fetchInventoryData();
  }, []);

  const tabs = [
    { 
      id: 'overview', 
      label: 'Overview', 
      svg: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg> 
    },
    { 
      id: 'integration', 
      label: 'MCP Integration', 
      svg: <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor' }}></div>
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <InventoryDashboard />;
      case 'integration':
        return <IntegrationTab />;
      default:
        return <InventoryDashboard />;
    }
  };

  return (
    <div className="inventory-container" style={{ backgroundColor: '#f8f9fa', minHeight: '100%', fontFamily: 'Inter, sans-serif', padding: '16px' }}>
      
      {/* Tabs Section */}
      <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #E5E7EB', marginBottom: '0', paddingBottom: '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          {tabs.map(tab => (
            activeTab === tab.id ? (
              <div key={tab.id} className="nav-item active" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px', borderRadius: '999px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', marginBottom: '8px', backgroundColor: '#8B5CF6', color: '#fff' }}>
                <div className="nav-dot" style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor' }}></div>
                {tab.label}
              </div>
            ) : (
              <div 
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#9CA3AF', fontSize: '14px', fontWeight: '500', paddingBottom: '12px', borderBottom: '2px solid transparent', cursor: 'pointer' }}
              >
                {tab.svg}
                {tab.label}
              </div>
            )
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ marginTop: '0' }}>
        {renderTabContent()}
      </div>

    </div>
  );
}

